module.exports = __webpack_public_path__ + "img/15.0ed77bc1.png";